module.exports = __webpack_public_path__ + "img/not-authorized-dark.b8831e2f.svg";